import {
  Component, Input
} from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';

@Component({
  selector: 'app-cardbox-one',
  templateUrl: './cardbox-one.component.html',
  styleUrls: ['./cardbox-one.component.scss'],
  standalone: false
})
export class CardboxOneComponent extends CoreClass {
  @Input() description: string = '';
  @Input() username: string = '';
  @Input() userimg: string = '';
  @Input() date: string = '';
  @Input() style: string | object = '';
  @Input() isTestimonial: boolean = false;
  @Input() rating: number = 5;
}
